import { BsFillShareFill, BsTwitterX } from 'react-icons/bs';
import { FacebookIcon, FacebookShareButton, LineIcon, LineShareButton, TwitterShareButton } from 'react-share';
import { APP_URL } from 'src/constants';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

const WidgetSocialShare = ({ articleLink, round = false, eventDataLayer = {} }: any) => {
  const shareLink = `${APP_URL}${articleLink}`;
  return (
    <>
      <WidgetWrapper className='widget-social-share'>
        <BsFillShareFill />
        <div className='article-share'>
          <ul className='social'>
            <li
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    title: 'facebook',
                    heading: 'facebook',
                    index: 1
                  }
                })
              }>
              <FacebookShareButton url={shareLink} aria-label='แชร์ไปยัง Facebook'>
                <FacebookIcon size={42} round={round} />
              </FacebookShareButton>
            </li>
            <li
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    title: 'twitter',
                    heading: 'twitter',
                    index: 1
                  }
                })
              }>
              <TwitterShareButton url={shareLink} aria-label='แชร์ไปยัง Twitter'>
                <div className='x-wrapper'>
                  <BsTwitterX />
                </div>
              </TwitterShareButton>
            </li>
            <li
              //! DATALAYER
              onClick={() =>
                sendDataLayerGlobal({
                  ...eventDataLayer,
                  data: {
                    title: 'line',
                    heading: 'line',
                    index: 1
                  }
                })
              }>
              <LineShareButton url={shareLink} aria-label='แชร์ไปยัง Line'>
                <LineIcon size={42} round={round} />
              </LineShareButton>
            </li>
          </ul>
        </div>
      </WidgetWrapper>
    </>
  );
};

const WidgetWrapper = styled.div`
  position: relative;
  background: rgb(208, 23, 51);
  display: flex;
  padding: 12px;
  transition: all 0.4s ease-in-out;
  width: fit-content;
  cursor: pointer;
  svg {
   color: white;
  }
  &:hover {
    .article-share {
      left: 42px;
      ul {
        li {
          opacity: 1;
        }
      }
    }
  }
  .article-share {
    transition: all 0.6s ease-in-out;
    position: absolute;
    bottom: -7px;
    left: 42px;
    ul {
      list-style-type: none;
      display: flex;
      justify-content: center;
      align-items: start;
      li {
        opacity: 0;
      }
      li:nth-child(1) {
        transition: opacity 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 50ms,
          background-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0s;
      }
      li:nth-child(2) {
        transition: opacity 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0.1s,
          background-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0s;
      }
      li:nth-child(3) {
        transition: opacity 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0.15s,
          background-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0s;
      }
      li:nth-child(4) {
        transition: opacity 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0.2s,
          background-color 0.3s cubic-bezier(0.35, 0.7, 0.32, 0.9) 0s;
      }
    }
    .x-wrapper {
        width: 42px;
        height: 42px;
        background-color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
      }
  }
`;

export default WidgetSocialShare;
